import React, { useEffect, useState } from "react";
import ComponentTable from "./componentTable";

const ComparisonList = ({
  imagesData,
  setImagePopup,
  openReasonPopup,
  handleFeedback,
  setOpenReasonPopup,
  data,
  handleUpdateFeedback,
  setQuestions,
  questions,
  setComponentType,
  componentType,
  localFeedbackData,
  setComponentFeedback,
  componentFeedback
}) => {
  const [hoverId, setHoverId] = useState(null);
  const [comparisonData, setComparisonData] = useState([]);

  let uniqueIdCounter = 1;

  const mapComponentsToTableData = (components) => {
    return components?.map((component) => {
      const claimDataApprove = "Dealer Reported";

      const systemResult = component?.systemComponentStatus;
      const isSystemResultApproved = "System Recommendations";

      const thead = [
        {
          name: component.componentName
        },
        {
          name: claimDataApprove,
          status: component?.componentStatus
        },
        {
          name: isSystemResultApproved,
          componentName: component.componentName,
          componentId: component?._id,
          isMoreDetailsAvaialble: true,
          reason: component?.systemDescription,
          feedback: localFeedbackData?.checks,
          status: component?.systemComponentStatus
        },
        {
          name: "Current System Value",
          status: component?.currentComponentStatus
        },
        {
          name: "Decision Status",
          isECEQueue:
            !data?.isEceQueue ||
            data.inspectionClaimStatus?.toLowerCase() === "open" ||
            (component?.currentComponentStatus?.toLowerCase() === "denied" &&
              component?.systemComponentStatus?.toLowerCase() === "denied")
        }
      ];

      const tbody = [];
      const damageDescription = component?.additionalQuestions;

      setQuestions((prev) => ({
        ...prev,
        [component.componentName]: damageDescription
      }));

      const matchingFeedbackDamage = localFeedbackData?.damageResults?.find(
        (feedback) =>
          feedback.componentName === component.componentName &&
          "Tire Damage Description" === feedback?.questionText
      );
      const matchingFeedbackDecision = localFeedbackData?.decisionStatus?.find(
        (feedback) =>
          feedback.componentName === component.componentName &&
          "Tire Damage Description" === feedback?.questionText
      );

      tbody.push({
        _id: uniqueIdCounter++,
        element: `${componentType === "TIRE" ? "Tire" : "Wheel"} Damage Description`,
        componentName: component.componentName,
        claimData:
          component.damageDescription ||
          component?.wheelDamageDescription ||
          "-",
        systemResults:
          component.systemDamageDescription ||
          (component?.isDamageIdentified !== null
            ? `${component.damageDescription || component?.wheelDamageDescription || "-"} ${
                component?.isDamageIdentified?.toLowerCase() === "yes"
                  ? "identified"
                  : "not identified"
              }`
            : "-"),
        result: component?.currentDamageDescription,
        feedbackDamage: matchingFeedbackDamage ? matchingFeedbackDamage : "",
        feedbackDecision: matchingFeedbackDecision
          ? matchingFeedbackDecision
          : "",
        componentType: component?.component,
        componentLocation: component.componentLocation,
        version: data?.version,
        decisionStatus:
          component?.decisionStatuses?.damageDescription?.status || null,
        decisionReason:
          component?.decisionStatuses?.damageDescription?.overrideReason,
        processingStatus: component?.processingStatus
      });

      if (component?.systemDamageLocation !== null) {
        const matchingFeedbackLocation = localFeedbackData?.damageResults?.find(
          (feedback) =>
            feedback.componentName === component.componentName &&
            "Tire Damage Location" === feedback?.questionText
        );
        const matchingFeedbackLocationDecision =
          localFeedbackData?.decisionStatus?.find(
            (feedback) =>
              feedback.componentName === component.componentName &&
              "Tire Damage Location" === feedback?.questionText
          );

        tbody.push({
          _id: uniqueIdCounter++,
          element: `${componentType === "TIRE" ? "Tire" : "Wheel"} Damage Location`,
          componentName: component.componentName,
          claimData: component?.damageLocation || "-",
          systemResults: component?.systemDamageLocation || "-",
          result: component?.currentDamageLocation,

          feedbackDamage: matchingFeedbackLocation
            ? matchingFeedbackLocation
            : "",
          feedbackDecision: matchingFeedbackLocationDecision
            ? matchingFeedbackLocationDecision
            : "",
          componentType: component?.component,
          componentLocation: component.componentLocation,
          version: data?.version,
          decisionStatus:
            component?.decisionStatuses?.damageLocation?.status || null,
          decisionReason:
            component?.decisionStatuses?.damageLocation?.overrideReason,
          processingStatus: component?.processingStatus
        });
      }

      const matchingFeedback = localFeedbackData?.damageResults?.find(
        (feedback) =>
          feedback.componentName === component.componentName &&
          "Corrective Action" === feedback?.questionText
      );
      const matchingFeedbackActionDecision =
        localFeedbackData?.decisionStatus?.find(
          (feedback) =>
            feedback.componentName === component.componentName &&
            "Corrective Action" === feedback?.questionText
        );

      tbody.push({
        _id: uniqueIdCounter++,
        element: "Corrective Action",
        componentName: component.componentName,
        claimData: component?.correctiveAction || "-",
        systemResults: component.systemCorrectiveAction || "-",
        result: component?.currentCorrectiveAction,
        version: data?.version,
        componentLocation: component.componentLocation,
        feedbackDamage: matchingFeedback ? matchingFeedback : "",
        feedbackDecision: matchingFeedbackActionDecision
          ? matchingFeedbackActionDecision
          : "",
        componentType: component?.component,

        decisionStatus:
          component?.decisionStatuses?.correctiveAction?.status || null,
        decisionReason:
          component?.decisionStatuses?.correctiveAction?.overrideReason,
        processingStatus: component?.processingStatus
      });

      tbody.push({
        sameTireResults: component?.sameTireResults,
        componentName: component.componentName,
        isSameTireAvaialble: true,
        sameTireResultFeedback: localFeedbackData?.sameTireResultFeedback,
        componentId: component?._id,
        componentType: component?.component,
        componentLocation: component.componentLocation
      });
      const diffInSeconds = (
        (component.processingEndTime - component.processingStartTime) /
        1000
      ).toFixed(2);
      tbody.push({
        mandatoryChecks: component?.mandatoryChecks,
        componentName: component.componentName,
        isMoreDetailsAvaialble: true,
        reason: component?.systemDamageExplanation,
        systemResult: systemResult,
        mandatoryFeedback: localFeedbackData?.mandatoryChecks,
        additionalFeedback: localFeedbackData?.additionalQuestions,
        componentId: component?._id,
        componentType: component?.component,
        componentLocation: component.componentLocation,
        errorMessage:
          component?.processingStatus === "DamageImagesMissing"
            ? "No Damage Images Found."
            : component?.errorMessage,
        slaTime: diffInSeconds
      });

      return { thead, tbody };
    });
  };

  useEffect(() => {
    let tableData;
    const componentTireData = data?.components?.filter(
      (item) => item.component?.toLowerCase() === "tire"
    );

    const actualValuesTire =
      data?.claimOverriddenDetails?.componentDetails?.filter(
        (item) => item.component?.toLowerCase() === "tire"
      );
    const componentWheelData = data?.components?.filter(
      (item) => item.component?.toLowerCase() === "wheel"
    );

    if (componentType === "TIRE") {
      tableData = mapComponentsToTableData(
        componentTireData,
        actualValuesTire || []
      );
    } else {
      tableData = mapComponentsToTableData(
        componentWheelData,
        actualValuesTire || []
      );
    }

    setComparisonData(tableData);
  }, [data, componentType, localFeedbackData]);

  return (
    <div>
      <div className="w-full ">
        <div className=" my-3 flex h-10 items-center justify-between">
          <div className="flex items-center gap-5">
            {data?.components?.find(
              (item) => item.component?.toLowerCase() === "tire"
            ) && (
              <span
                onClick={() => setComponentType("TIRE")}
                className={` ${componentType === "TIRE" ? "border border-green-10 bg-green-10" : "border border-grey-10 bg-white"} w-20 cursor-pointer rounded-lg bg-opacity-10 py-2 text-center font-InterMedium text-ft16-24 text-black-0`}
              >
                Tire
              </span>
            )}
            {data?.components?.find(
              (item) => item.componentType?.toLowerCase() === "wheel"
            ) && (
              <span
                onClick={() => setComponentType("WHEEL")}
                className={` ${componentType === "WHEEL" ? "border border-green-10 bg-green-10" : "border border-grey-10 bg-white"} w-20 cursor-pointer rounded-lg bg-opacity-10 py-2 text-center font-InterMedium text-ft16-24 text-black-0`}
              >
                Wheel
              </span>
            )}
          </div>
          {data?.inspectionClaimStatus && (
            <div className="flex items-center gap-5">
              <span className="font-InterMedium text-ft16-24 text-black-0">
                Claim Inspection Status:
              </span>
              <span
                className={`rounded-lg border px-4 py-2 text-center font-InterMedium text-ft16-24 ${
                  data.inspectionClaimStatus?.toLowerCase() === "approved"
                    ? "border-green-10 bg-green-10 bg-opacity-10 text-green-10"
                    : data.inspectionClaimStatus?.toLowerCase() === "denied" ||
                        data.inspectionClaimStatus?.toLowerCase() === "cancel"
                      ? "border-red-10 bg-red-10 bg-opacity-10 text-red-10"
                      : data.inspectionClaimStatus?.toLowerCase() === "open"
                        ? "border-blue-50 bg-blue-50 bg-opacity-10 text-blue-40"
                        : "border-grey-10 bg-white text-black-0"
                }`}
              >
                {data.inspectionClaimStatus}
              </span>
            </div>
          )}
        </div>
        {comparisonData?.map((item, idx) => (
          <div key={idx}>
            <ComponentTable
              openReasonPopup={openReasonPopup}
              setImagePopup={setImagePopup}
              setOpenReasonPopup={setOpenReasonPopup}
              tbody={item.tbody}
              thead={item.thead}
              hoverId={hoverId}
              data={data}
              imagesData={imagesData}
              setHoverId={setHoverId}
              handleFeedback={handleFeedback}
              handleUpdateFeedback={handleUpdateFeedback}
              feedback={localFeedbackData}
              questions={questions}
              setComponentFeedback={setComponentFeedback}
              componentFeedback={componentFeedback}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ComparisonList;
